export default {"src":"/_next/static/media/manage.279a33fa.svg","height":42,"width":42};